import {useSearchParams} from 'react-router-dom';
import {useCallback, useMemo} from "react";

const useQueryParam = (key) => {
  let [searchParams, setSearchParams] = useSearchParams();
  
  let paramValue = searchParams.get(key);
  
  let value = useMemo(() => paramValue, [paramValue]);
  
  let setValue = useCallback((newValue, options) => {
    let newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, newValue);
    setSearchParams(newSearchParams, options);
  }, [key, searchParams, setSearchParams]);
  
  return [value, setValue];
};

export {useQueryParam};
